import { Button, Alert, Modal } from "react-bootstrap";
import React, { memo, useState } from "react";
import "./template-tasks-modal.scss";
import TemplateTasksContainerNew from "./template-tasks-container/TemplateTasksContainerNew";
import PropTypes from "prop-types";

const TasksModalNew = ({ show, onHide, templateName, templateID }) => {
  const [alertConfig, setAlertConfig] = useState({
    showAlert: false,
    alertAction: "",
    alertMessage: "",
    alertVariant: "danger",
  });

  return (
    <Modal
      className="template-modal"
      centered
      show={show}
      onHide={onHide ?? (() => (show = false))}
    >
      <Modal.Header className="template-modal-header" closeButton>
        <div className="template-modal-name">{templateName}</div>

        {alertConfig.showAlert && (
          <Alert
            show={alertConfig.showAlert}
            onClose={() =>
              setAlertConfig((prevState) => ({
                ...prevState,
                showAlert: false,
              }))
            }
            variant="danger"
            className="template-modal-alert"
            dismissible
          >
            <Alert.Heading>{"Unable to Upload File(s)!"}</Alert.Heading>
            <p>{alertConfig.alertMessage}</p>
            <hr />
            <div className="d-flex justify-content-end"></div>
          </Alert>
        )}
      </Modal.Header>

      <Modal.Body className="template-modal-body">
        <TemplateTasksContainerNew
          templateName={templateName}
          templateID={templateID}
          setAlertConfig={setAlertConfig}
        />
      </Modal.Body>

      <Modal.Footer className="template-modal-footer">
        <Button
          className="back-button btn-outlined"
          onClick={onHide ?? (() => (show = false))}
        >
          Back
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

TasksModalNew.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func,
  templateName: PropTypes.string.isRequired,
  templateID: PropTypes.number.isRequired,
};

export default memo(TasksModalNew);
